if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        if (!button) return;

        if (this.dataset.showMoreContent) {
          this.initializeContentToggle(button);
          return;
        }

        button.addEventListener('click', (event) => {
          this.expandShowMore(event);
          const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
          if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
            nextElementToFocus.querySelector('input').focus();
          }
        });
      }
      initializeContentToggle(button) {
        const content = document.getElementById(this.dataset.showMoreContent);
        if (!content) return;

        const updateVisibility = () => {
          const isExpanded = content.classList.contains('is-expanded');
          this.hidden = !isExpanded && content.scrollHeight <= content.clientHeight + 1;
        };

        button.addEventListener('click', () => {
          const isExpanded = content.classList.toggle('is-expanded');
          button.setAttribute('aria-expanded', isExpanded);
          this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
          updateVisibility();
        });

        updateVisibility();
        window.addEventListener('resize', updateVisibility);
      }
      expandShowMore(event) {
        const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
        const parentWrap = parentDisplay.querySelector('.parent-wrap');
        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    }
  );
}
